import * as ApiKey from 'types/User/Admin/UserApiKey/UserApiKey';
import * as ApiKeyList from 'types/User/Admin/UserApiKey/UserApiKeyList';

export type Type = {
	apiKeys: ApiKeyList.Type;
	currentApiKeyId: string | null;
};

export function create(): Type {
	return {
		apiKeys: ApiKeyList.create(),
		currentApiKeyId: null,
	};
}

export function setApiKeys(state: Type, apiKeys: ApiKey.Type[]): Type {
	return { ...state, apiKeys: apiKeys };
}

export function addApiKey(state: Type, apiKey: ApiKey.Type): Type {
	return { ...state, apiKeys: [...state.apiKeys, apiKey] };
}

export function clickCancel(state: Type): Type {
	return {
		...state,
		apiKeys: ApiKeyList.removeNewApiKeys(state.apiKeys),
		currentApiKeyId: null,
	};
}

export function addNewApiKey(state: Type): Type {
	return {
		...state,
		apiKeys: [...state.apiKeys, { ...ApiKey.create(), id: 'new' }],
		currentApiKeyId: 'new',
	};
}

export async function removeApiKey(state?: Type, apiKeyId?: string): Promise<Type> {
	if (state === undefined || apiKeyId === undefined) return create();
	await ApiKey.deleteFromApi(apiKeyId);
	return {
		...state,
		apiKeys: state.apiKeys.filter((e) => e.id !== apiKeyId),
		currentApiKeyId: null,
	};
}

export function changeName(
	state: Type,
	input: {
		apiKey: ApiKey.Type;
		name: string;
	}
): Type {
	return {
		...state,
		apiKeys: ApiKeyList.changeName(state.apiKeys, {
			apiKeyId: input.apiKey.id,
			name: input.name,
		}),
	};
}

export function setCurrentApiKeyId(state: Type, apiKeyId: string | null): Type {
	return { ...state, currentApiKeyId: apiKeyId };
}

export async function generateApiKey(state?: Type, apiKey?: ApiKey.Type): Promise<Type> {
	if (state === undefined) return create();
	if (apiKey === undefined) return state;
	if (state.currentApiKeyId === null) {
		return state;
	}
	const key = await ApiKey.generateToApi(apiKey);
	return {
		...state,
		apiKeys: [...ApiKeyList.removeNewApiKeys(state.apiKeys), key],
		currentApiKeyId: key.id,
	};
}

export function getCurrentApiKey(state: Type): ApiKey.Type | undefined {
	return state.apiKeys.find((e) => e.id === state.currentApiKeyId);
}

export async function saveApiKey(state?: Type, apiKey?: ApiKey.Type): Promise<Type> {
	if (state === undefined || apiKey === undefined) return create();
	return {
		...state,
		apiKeys: await ApiKeyList.saveApiKey(state.apiKeys, apiKey),
		currentApiKeyId: null,
	};
}
